module.exports = __webpack_public_path__ + "static/media/bg-star.601bf9f9.svg";